<template lang="pug">
    aiq-image(:src="imageUrl" @click="previewBoxVisible = true")
    aiq-dialog.dialog-transparent(v-model="previewBoxVisible"
                    :show-close="false"
                    :close-on-click-modal="true"
                    :append-to-body="false"
                    :fullscreen="true"
                    top="0vh"
                    modal-class="imagePopup")
        .el-dialog__body(@click="previewBoxVisible = false")
        aiq-image(:src="imageUrl" @click="previewBoxVisible = false")
</template>

<script>

export default {
  name: 'ImageContainer',
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      previewBoxVisible: false,
    };
  },
};
</script>